module.exports = __webpack_public_path__ + "static/images/cardBg.d1c351a.png";